/* ============================================================
   Badache — Système de devis (panier devis séparé)
   Stockage local (localStorage), aucun back-office requis.
   - Bouton "Demander un devis" sur les fiches produits
   - Tiroir devis global (data-bd-devis-drawer)
   - Page devis (/pages/devis) : récap + formulaire de contact natif
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'bd_devis_v1';

  /* ---------- utilitaires ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function parseMoney(str) {
    if (!str) return 0;
    var s = String(str).replace(/[^0-9.,]/g, '');
    if (s.indexOf(',') > -1) { s = s.replace(/\./g, '').replace(',', '.'); }
    var n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  }
  function fmtMoney(n) {
    return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------- état ---------- */
  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var a = raw ? JSON.parse(raw) : [];
      return Array.isArray(a) ? a : [];
    } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
    sync();
  }
  function add(item) {
    var arr = read(), found = null;
    for (var i = 0; i < arr.length; i++) {
      if (String(arr[i].id) === String(item.id)) { found = arr[i]; break; }
    }
    if (found) { found.qty = (parseInt(found.qty, 10) || 1) + (parseInt(item.qty, 10) || 1); }
    else { arr.push(item); }
    write(arr);
  }
  function updateQty(id, qty) {
    var arr = read();
    qty = parseInt(qty, 10) || 1;
    if (qty < 1) qty = 1;
    for (var i = 0; i < arr.length; i++) {
      if (String(arr[i].id) === String(id)) { arr[i].qty = qty; break; }
    }
    write(arr);
  }
  function remove(id) {
    write(read().filter(function (i) { return String(i.id) !== String(id); }));
  }
  function clear() { write([]); }
  function subtotal() {
    return read().reduce(function (n, i) {
      return n + parseMoney(i.price) * (parseInt(i.qty, 10) || 1);
    }, 0);
  }

  /* ---------- texte pour l'email ---------- */
  function formatText() {
    var arr = read();
    if (!arr.length) return '';
    var lines = ['Produits demandés :', ''];
    arr.forEach(function (i) {
      var l = '• ' + i.title;
      if (i.variant) l += ' - ' + i.variant;
      lines.push(l);
      if (i.sku) lines.push('   Réf. ' + i.sku);
      var sub = '   Qté ' + (i.qty || 1);
      if (i.price) sub += ' · ' + i.price + ' /u';
      lines.push(sub);
      if (i.url) lines.push('   ' + location.origin + i.url);
      lines.push('');
    });
    lines.push('Total indicatif : ' + fmtMoney(subtotal()));
    return lines.join('\n');
  }

  /* ---------- rendu ---------- */
  function itemHTML(i) {
    var img = i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">' : '';
    var variant = i.variant ? '<p class="bd-di__variant">' + esc(i.variant) + '</p>' : '';
    var ref = i.sku ? '<p class="bd-di__ref">Réf. ' + esc(i.sku) + '</p>' : '';
    var qtyN = parseInt(i.qty, 10) || 1;
    var lineTotal = parseMoney(i.price) * qtyN;
    var prices = '<div class="bd-di__prices">' +
        '<span class="bd-di__linetotal">' + esc(fmtMoney(lineTotal)) + '</span>' +
        (i.price ? '<span class="bd-di__price">' + esc(i.price) + '</span>' : '') +
      '</div>';
    return '<li class="bd-di" data-id="' + esc(i.id) + '">' +
        '<a class="bd-di__media" href="' + esc(i.url || '#') + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="bd-di__info">' +
          '<a class="bd-di__title" href="' + esc(i.url || '#') + '">' + esc(i.title) + '</a>' +
          variant + ref +
          '<div class="bd-di__row">' +
            '<div class="bd-di__qty">' +
              '<button type="button" data-devis-minus aria-label="Diminuer">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
              '<input type="number" min="1" value="' + (parseInt(i.qty, 10) || 1) + '" data-devis-qty aria-label="Quantité">' +
              '<button type="button" data-devis-plus aria-label="Augmenter">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
            '</div>' +
            prices +
            '<button type="button" class="bd-di__remove" data-devis-remove aria-label="Retirer">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg></button>' +
          '</div>' +
        '</div>' +
      '</li>';
  }

  function sync() {
    var arr = read(), n = arr.length;
    document.querySelectorAll('[data-bd-devis-count]').forEach(function (el) {
      el.textContent = n; el.classList.toggle('is-empty', n === 0);
    });
    document.querySelectorAll('[data-bd-devis-count-label]').forEach(function (el) {
      el.textContent = n > 0 ? ('(' + n + ')') : '';
    });
    document.querySelectorAll('[data-bd-devis-list]').forEach(function (ul) {
      ul.innerHTML = arr.map(itemHTML).join('');
    });
    document.querySelectorAll('[data-bd-devis-empty]').forEach(function (el) { el.hidden = n > 0; });
    document.querySelectorAll('[data-bd-devis-footer]').forEach(function (el) { el.hidden = n === 0; });
    document.querySelectorAll('[data-bd-devis-subtotal]').forEach(function (el) { el.textContent = fmtMoney(subtotal()); });
    document.querySelectorAll('[data-bd-devis-submit]').forEach(function (el) { el.classList.toggle('is-disabled', n === 0); });
  }

  /* ---------- tiroir ---------- */
  function openDrawer() {
    var d = document.querySelector('[data-bd-devis-drawer]');
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bd-devis-open');
  }
  function closeDrawer() {
    var d = document.querySelector('[data-bd-devis-drawer]');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bd-devis-open');
  }

  /* ---------- ajout depuis une fiche produit ---------- */
  function flashBtn(btn) {
    var sp = btn.querySelector('span');
    if (!sp) return;
    if (btn._bdBusy) return;
    btn._bdBusy = true;
    var old = sp.textContent;
    btn.classList.add('is-added');
    sp.textContent = 'Ajouté au devis ✓';
    setTimeout(function () {
      sp.textContent = old;
      btn.classList.remove('is-added');
      btn._bdBusy = false;
    }, 1400);
  }
  function handleAdd(btn) {
    var scope = btn.closest('.bd-product') || document;
    var idInput = scope.querySelector('.bd-form input[name="id"]');
    var id = idInput ? idInput.value : (btn.getAttribute('data-devis-vid') || '');
    if (!id) return;
    var priceEl = scope.querySelector('.bd-price');
    var qtyEl = scope.querySelector('.bd-qty input');
    var titleEl = scope.querySelector('.bd-title');
    var variant = '';
    var curs = scope.querySelectorAll('.bd-variant-option [data-option-current]');
    if (curs.length) {
      variant = Array.prototype.map.call(curs, function (e) { return e.textContent.trim(); })
        .filter(Boolean).join(' · ');
    }
    var imgEl = scope.querySelector('.pic.is-active img') ||
                scope.querySelector('.pic img') ||
                scope.querySelector('.bd-thumb img');
    var skuEl = scope.querySelector('.bd-sku');
    add({
      id: String(id),
      pid: btn.getAttribute('data-devis-pid') || '',
      title: btn.getAttribute('data-devis-title') || (titleEl ? titleEl.textContent.trim() : ''),
      variant: variant,
      sku: skuEl ? (skuEl.getAttribute('data-sku') || '') : '',
      price: priceEl ? priceEl.textContent.trim() : '',
      url: btn.getAttribute('data-devis-url') || '',
      image: imgEl ? imgEl.getAttribute('src') : '',
      qty: qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1
    });
    flashBtn(btn);
    openDrawer();
  }

  /* ---------- délégation d'événements ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var addBtn = t.closest && t.closest('[data-bd-devis-add]');
    if (addBtn) { e.preventDefault(); handleAdd(addBtn); return; }
    var openTrig = t.closest && t.closest('[data-bd-devis-open]');
    if (openTrig) {
      if (read().length === 0) { e.preventDefault(); window.location.href = '/pages/devis'; return; }
      e.preventDefault(); openDrawer(); return;
    }
    if (t.closest && t.closest('[data-bd-devis-close]')) { e.preventDefault(); closeDrawer(); return; }

    var submit = t.closest && t.closest('[data-bd-devis-submit]');
    if (submit && submit.classList.contains('is-disabled')) { e.preventDefault(); return; }

    var li = t.closest && t.closest('.bd-di');
    if (li) {
      var id = li.getAttribute('data-id');
      if (t.closest('[data-devis-remove]')) { remove(id); return; }
      if (t.closest('[data-devis-plus]')) {
        var inp = li.querySelector('[data-devis-qty]');
        updateQty(id, (parseInt(inp.value, 10) || 1) + 1); return;
      }
      if (t.closest('[data-devis-minus]')) {
        var inp2 = li.querySelector('[data-devis-qty]');
        updateQty(id, (parseInt(inp2.value, 10) || 1) - 1); return;
      }
    }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('[data-devis-qty]');
    if (!inp) return;
    var li = inp.closest('.bd-di');
    if (li) updateQty(li.getAttribute('data-id'), inp.value);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- page devis : injection dans le formulaire + succès ---------- */
  function initForm() {
    var form = document.querySelector('[data-bd-devis-form]');
    if (!form) return;
    if (form.querySelector('[data-bd-devis-success]') || /[?&]contact_posted=true/.test(location.search)) {
      clear();
      return;
    }
    form.addEventListener('submit', function () {
      var hidden = form.querySelector('[data-bd-devis-body]');
      if (!hidden) return;
      var msgEl = form.querySelector('[data-bd-devis-message]');
      var msg = msgEl ? msgEl.value.trim() : '';
      var list = formatText();
      var out = list;
      if (msg) { out += (list ? '\n\n' : '') + 'Message du client :\n' + msg; }
      hidden.value = out;
    });
  }

  function init() { sync(); initForm(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  window.BadacheDevis = {
    add: add, remove: remove, updateQty: updateQty, clear: clear,
    read: read, count: function () { return read().length; },
    open: openDrawer, close: closeDrawer, sync: sync
  };
})();
